document.addEventListener('DOMContentLoaded', function(){

  // ▼ LCP後に実行（最重要）
  requestAnimationFrame(() => {

    // メインスライダー（LCP対象）
    if(document.querySelector('#slider')){
      new Swiper('#slider', {
        loop: true,
        centeredSlides: true,
        autoplay: { delay: 6000, disableOnInteraction: false },
        slidesPerView: 'auto',
        speed: 600,
        breakpoints: {
          768: {
            slidesPerView: 1.1,
            spaceBetween: 20
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
      });
    }

  });

  // ▼ 下のスライダーは遅延（スクロール後）
  const initOnScroll = (selector, options) => {
    const el = document.querySelector(selector);
    if(!el) return;

    const observer = new IntersectionObserver((entries) => {
      if(entries[0].isIntersecting){
        new Swiper(selector, options);
        observer.disconnect();
      }
    });

    observer.observe(el);
  };

  // request_slider
  initOnScroll('#request_slider', {
    slidesPerView: "auto",
    slidesPerGroup: 7,
    speed: 600,
    breakpoints: {
      768: {
        slidesPerView: 2.4,
        spaceBetween: 20
      }
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });

  // new_arrival
  initOnScroll('#new_arrival_slider', {
    slidesPerView: "auto",
    slidesPerGroup: 7,
    speed: 600
  });

  // recommend
  initOnScroll('#recommend_slider', {
    slidesPerView: "auto",
    slidesPerGroup: 7,
    speed: 600
  });

  // ranking
  initOnScroll('#ranking_slider', {
    slidesPerView: "auto",
    slidesPerGroup: 7,
    speed: 600
  });

});